import { Button } from 'reactstrap'
import { primary_color } from '../../../../Helper/uiHelper'
import { AvForm } from 'availity-reactstrap-validation'
import RenderFields from '../../../../CMSComponent/Forms/renderFields'
import { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { clearCurrentRowData, clearParentTableData, fetchUpdateApiData } from '../../../../Redux/Reducers/CMS'
import { request } from '../../../../Redux/Sagas/requests/api'
import { cms, isSuccessResponse } from '../../../../helper'
import { useHistory } from 'react-router-dom'

const AddEditFAQ = ({ addFormList, setAddGridDataDetail, addDataDetail }) => {
  const saveNclose = useRef()
  const currentRow = useSelector((state) => state.CMS.currentRow)
  const dispatch = useDispatch()
  const history = useHistory()

  const [formFieldValue, setFormFieldValue] = useState(currentRow?.[1])
  const [defaultSingleFormValue, setDefaultSingleFormValue] = useState(currentRow?.[0])
  const [defaultId, setDefaultId] = useState()
  const [loading, setLoading] = useState(false)

  const onCloseForm = () => {
    dispatch(fetchUpdateApiData())
    if (!addDataDetail?.isAddNew) {
      dispatch(clearCurrentRowData())
      dispatch(clearParentTableData())
    }

    setAddGridDataDetail({ open: false })
  }

  const onSave = (values) => {
    let data = {
      ...values,
    }
    if (!addDataDetail?.isAddNew) {
      data = {
        ...data,
        id: currentRow?.[0]?.id,
      }
    }
    if (defaultId) {
      data = {
        ...data,
        id: defaultId,
      }
    }
    request('insert-repeating-grid-data', 'POST', {
      is_nested: true,
      data: {
        [addDataDetail?.tableGrid?.source_table]: [data],
      },
    }).then((res) => {
      if (isSuccessResponse(res, 'Form submitted successfully!')) {
        setLoading(false)
        if (saveNclose.current) {
          onCloseForm()
        } else {
          setDefaultId(res?.data?.data)
        }
      }
    })
  }

  return (
    <div className='p-4'>
      <div className='mb-4'>
        <Button
          color='dark'
          onClick={() => {
            onCloseForm()
          }}>
          <i class='fa-solid fa-arrow-left'></i>
        </Button>
      </div>
      <div style={{ color: primary_color }} className='body1 mb-3 font-weight-bold'>
        {addDataDetail?.isAddNew ? 'Add FAQ' : 'Edit FAQ'}
      </div>
      <div className='mb-3'>
        {' '}
        <Button
          style={{ background: primary_color }}
          className='subtitle1'
          onClick={() => {
            history.push('/query-types-list')
          }}>
          {cms('heading.query_types') || 'Manage Queries'}
        </Button>
      </div>

      <AvForm
        onValidSubmit={(e, values) => {
          onSave(values)
        }}>
        <RenderFields
          content={addFormList}
          allForm={addFormList}
          formFieldValue={formFieldValue}
          setFormFieldValue={setFormFieldValue}
          defaultFormValue={defaultSingleFormValue}
        />
        <div className='d-flex justify-content-end mt-5'>
          {' '}
          <button
            className='btn rounded-pill mt-2 text-danger border-danger mr-3'
            type='button'
            id='close-btn'
            onClick={(e) => {
              onCloseForm()
              e.preventDefault()
              e.stopPropagation()
            }}
            style={{ fontWeight: 700, width: '12rem' }}>
            Close
          </button>
          <button
            className='btn text-white rounded-pill mt-2 mr-3'
            disabled={!!loading}
            type='submit'
            id='save-button'
            style={{ background: primary_color, fontWeight: 700, width: '14rem' }}>
            {loading ? 'Saving...' : 'Save'}
          </button>
          <button
            className='btn text-white rounded-pill mt-2 mr-3'
            disabled={!!loading}
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              saveNclose.current = true
              const ele = document.getElementById('save-button')
              if (ele) {
                ele.click()
              }
            }}
            type='submit'
            style={{ background: primary_color, fontWeight: 700, width: '14rem' }}>
            Save & Close
          </button>
        </div>
      </AvForm>
    </div>
  )
}

export default AddEditFAQ
